/**
 * The colour of a cell of "My office network" (CU-869fmjzrh CA 13, UX Obs. 5; Season's decision 1): green = you are
 * cheaper than the market (or your distance fell), red = dearer (or rose); three intensities, a neutral band around 0,
 * and always a sign and an arrow, never colour alone. Without identity the cell is the market median's change, with
 * smaller steps. Shared by My office network and DS Repricing › Last changes (lifted from Office network's
 * `@services/` in CU-869fn0gcp phase 2, behaviour unchanged). Pure and alias-free.
 */

export const NEUTRAL = 0.02
export const DISTANCE_STEPS = Object.freeze([0.02, 0.05, 0.10])
export const MARKET_STEPS = Object.freeze([0.01, 0.03, 0.06])
// the rankings take a cell from the neutral band out, and a change of half a point
export const RANK_MIN = NEUTRAL
export const CHANGE_MIN_POINTS = 0.5
export const MARKET_MOVE_MIN = MARKET_STEPS[0]

const isNum = v => typeof v === 'number' && Number.isFinite(v)

/**
 * `{ level: 0..3, side: 'cheaper'|'dearer'|'inline', arrow: '▼'|'▲'|'≈' }` for a ratio (−0.08 = 8 % below).
 * `null` without a value.
 */
export function tone(ratio, steps = DISTANCE_STEPS) {
	if (!isNum(ratio)) return null
	const a = Math.abs(ratio)
	if (a < steps[0]) return { level: 0, side: 'inline', arrow: '≈' }
	const level = a >= steps[2] ? 3 : a >= steps[1] ? 2 : 1
	return ratio < 0 ? { level, side: 'cheaper', arrow: '▼' } : { level, side: 'dearer', arrow: '▲' }
}

export const marketTone = ratio => tone(ratio, MARKET_STEPS)

/** `+8.4%` · `−12.0%` · `+1.2%` (one decimal, the true minus sign) */
export function pct(ratio) {
	if (!isNum(ratio)) return ''
	const r = Math.round(ratio * 1000) / 10
	if (r === 0) return '0.0%'
	return `${r > 0 ? '+' : '−'}${Math.abs(r).toFixed(1)}%`
}

/** `+2.1 pt` · `−0.6 pt` */
export function points(p) {
	if (!isNum(p)) return ''
	const r = Math.round(p * 10) / 10
	return `${r > 0 ? '+' : r < 0 ? '−' : ''}${Math.abs(r).toFixed(1)} pt`
}
